export function uniqueIds(values = []) {
  return Array.from(new Set(
    (Array.isArray(values) ? values : [values])
      .map((value) => `${value || ""}`.trim())
      .filter(Boolean)
  ));
}

export function getVolunteerCoordinatorIds(volunteer) {
  const legacy = `${volunteer?.coordinatorId || ""}`.trim();
  const current = Array.isArray(volunteer?.coordinatorIds) ? volunteer.coordinatorIds : [];
  return uniqueIds([...current, legacy]);
}

export function getPrimaryCoordinatorId(volunteer) {
  return getVolunteerCoordinatorIds(volunteer)[0] || "";
}

export function getVolunteerTeamLeadIds(volunteer) {
  const legacy = `${volunteer?.teamLeadVolunteerId || ""}`.trim();
  const current = Array.isArray(volunteer?.teamLeadVolunteerIds) ? volunteer.teamLeadVolunteerIds : [];
  return uniqueIds([...current, legacy]);
}

export function getPrimaryTeamLeadId(volunteer) {
  return getVolunteerTeamLeadIds(volunteer)[0] || "";
}

export function hasVolunteerCoordinatorId(volunteer, coordinatorId) {
  const normalized = `${coordinatorId || ""}`.trim();
  if (!normalized) return false;
  return getVolunteerCoordinatorIds(volunteer).includes(normalized);
}

export function hasVolunteerTeamLeadId(volunteer, teamLeadVolunteerId) {
  const normalized = `${teamLeadVolunteerId || ""}`.trim();
  if (!normalized) return false;
  return getVolunteerTeamLeadIds(volunteer).includes(normalized);
}
